import { Objects } from '@/types/objects';

export const entries = <T extends object>(obj: T): Objects.Entries<Required<T>> =>
    Object.entries(obj) as Objects.Entries<T>;

export const keys = <T extends object>(obj: T): Objects.Keys<T> =>
    Object.keys(obj) as Objects.Keys<T>;

export const values = <T extends object>(obj: T): Objects.Values<T> =>
    Object.values(obj) as Objects.Values<T>;
